/**
 * @generated SignedSource<<9563d5dc14588e71d784a0c77e58ffbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItemVATReportLink_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_notifications">;
  readonly " $fragmentType": "NavItemVATReportLink_notifications";
};
export type NavItemVATReportLink_notifications$key = {
  readonly " $data"?: NavItemVATReportLink_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItemVATReportLink_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "9591cb63c3265b12098db7239a5538bf";

export default node;
